import {
  RadioGroup,
  RadioGroupItem,
} from "@/shared/components/common/RadioButton";
import Label from "@/shared/components/common/input/Label";
import Flex from "@/shared/components/common/Flex";

type LocationType = "domestic" | "international";

interface LocationTypeProps {
  variants: { title: string; variant: string }[];
  locationType: LocationType;
  onSelect: (location: LocationType) => void;
}

export default function LocationType({
  variants,
  locationType,
  onSelect,
}: LocationTypeProps) {
  return (
    <Flex className="w-full justify-evenly py-2 border-t border-b ">
      <RadioGroup
        defaultValue={locationType}
        className="flex justify-evenly w-full"
      >
        {variants.map(({ title, variant }) => (
          <Flex className="items-center space-x-2" key={variant}>
            <RadioGroupItem
              value={variant}
              id={`toCreateUniqueId-${variant}`}
              onClick={() => onSelect(variant as LocationType)}
              hidden
            />
            <Label
              htmlFor={`toCreateUniqueId-${variant}`}
              className={`cursor-pointer hover:bg-muted dark:hover:bg-muted/10 rounded-xs px-8 h-full py-3  ${
                variant == locationType &&
                "bg-primary text-background hover:bg-primary"
              }`}
            >
              {title}
            </Label>
          </Flex>
        ))}
      </RadioGroup>
    </Flex>
  );
}
